import { render, staticRenderFns } from "./ProsesPermohonan.vue?vue&type=template&id=c44e12d8&"
import script from "./ProsesPermohonan.vue?vue&type=script&lang=js&"
export * from "./ProsesPermohonan.vue?vue&type=script&lang=js&"
import style0 from "./ProsesPermohonan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports